<template>
  <div id="register" class="jf-cta section">
    <div class="jf-cta__bg">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2 text-center">
            <h2 class="jf-cta__title">Ready to Find Your Next Opportunity?</h2>
            <p class="jf-cta__text">
              Don't miss our 4th annual Macher Job Fair. Meet 30+ employers, attend career workshops, and enjoy exclusive networking sessions with hiring managers.
            </p>
            <div class="jf-cta__pricing">
              <nuxt-link to="/dashboard/JobFair?ticketType=0" class="jf-cta__ticket">
                <span class="jf-cta__ticket-name">Job Seeker</span>
                <span class="jf-cta__ticket-price">$20</span>
                <span class="jf-cta__ticket-desc">Access all booths, workshops & panels</span>
                <span class="jf-cta__ticket-btn">Get Ticket <i class="icon-feather-arrow-right"></i></span>
              </nuxt-link>
              <nuxt-link to="/dashboard/JobFair?ticketType=1" class="jf-cta__ticket jf-cta__ticket--featured">
                <span class="jf-cta__ticket-name">Networking Ticket</span>
                <span class="jf-cta__ticket-price">$50</span>
                <span class="jf-cta__ticket-desc">For business owners & professionals</span>
                <span class="jf-cta__ticket-btn">Get Ticket <i class="icon-feather-arrow-right"></i></span>
              </nuxt-link>
              <nuxt-link to="/dashboard/JobFair?ticketType=2" class="jf-cta__ticket">
                <span class="jf-cta__ticket-name">Employer</span>
                <span class="jf-cta__ticket-price">From $250</span>
                <span class="jf-cta__ticket-desc">Meet qualified candidates in one day</span>
                <span class="jf-cta__ticket-btn">Get Ticket <i class="icon-feather-arrow-right"></i></span>
              </nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.jf-cta {
  padding: 0;

  &__bg {
    background: linear-gradient(135deg, #1a2a6c 0%, #2a41e8 50%, #4a6cf7 100%);
    padding: 80px 0;
  }

  &__title {
    color: #fff;
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 15px;
    line-height: 1.4;
  }

  &__text {
    color: rgba(255, 255, 255, 0.9);
    font-size: 18px;
    margin-bottom: 30px;
    line-height: 1.6;
  }

  &__button {
    background: #fff !important;
    color: #2a41e8 !important;
    font-weight: 600;
    padding: 14px 50px !important;
    font-size: 18px !important;
    border-radius: 4px;

    &:hover {
      background: #f0f0f0 !important;
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
    }

    i {
      margin-left: 8px;
    }
  }

  &__pricing {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 30px;
    flex-wrap: wrap;

    > a {
      flex: 1;
      max-width: 280px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  &__ticket {
    display: block;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 12px;
    padding: 25px 35px;
    min-width: 220px;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.25s;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
      border-color: rgba(255, 255, 255, 0.6);
      transform: translateY(-4px);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    }

    &--featured {
      background: rgba(255, 255, 255, 0.18);
      border-color: rgba(255, 255, 255, 0.5);
    }
  }

  &__ticket-name {
    display: block;
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 8px;
  }

  &__ticket-price {
    display: block;
    color: #fff;
    font-size: 36px;
    font-weight: 700;
    line-height: 1.2;
  }

  &__ticket-price-note {
    display: block;
    color: rgba(255, 255, 255, 0.85);
    font-size: 12px;
    font-style: italic;
    font-weight: 500;
    margin-top: 4px;
  }

  &__ticket-desc {
    display: block;
    color: rgba(255, 255, 255, 0.6);
    font-size: 12px;
    margin-top: 6px;
  }

  &__ticket-btn {
    display: inline-block;
    margin-top: 15px;
    background: #fff;
    color: #2a41e8;
    font-size: 14px;
    font-weight: 600;
    padding: 8px 24px;
    border-radius: 4px;
    transition: background 0.2s;

    i {
      margin-left: 5px;
      font-size: 12px;
    }
  }

  &__ticket:hover &__ticket-btn {
    background: #f0f0f0;
  }

  &__employer {
    margin-top: 25px;
    color: rgba(255, 255, 255, 0.75);
    font-size: 15px;

    a {
      color: #fff;
      font-weight: 600;
      text-decoration: underline;
      text-underline-offset: 3px;

      &:hover {
        color: #fff;
        text-decoration-thickness: 2px;
      }

      i {
        margin-left: 4px;
        font-size: 13px;
      }
    }
  }
}

@media (max-width: 768px) {
  .jf-cta {
    &__bg {
      padding: 50px 0;
    }

    &__title {
      font-size: 26px;
    }

    &__text {
      font-size: 15px;
    }
  }
}
</style>
